import { configureStore } from "@reduxjs/toolkit";
import { noLoginApi } from "./api/noLoginApi";

import { signularisApi } from './api/signularisApi'
import { userinfoSlice } from './slices/userinfoSlice'
import { statsApi } from "./api/statsApi";

export const store = configureStore({
  reducer: {
    [signularisApi.reducerPath]: signularisApi.reducer,
    [noLoginApi.reducerPath]: noLoginApi.reducer,
    [statsApi.reducerPath]: statsApi.reducer,
    userinfo: userinfoSlice.reducer
  },
  middleware: (getDefaultMiddleware) => 
    getDefaultMiddleware().concat(signularisApi.middleware).concat(statsApi.middleware)
})

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch